import React, { useState } from "react";
import { connect } from "react-redux";
import { Card } from "react-bootstrap";

import PlayButton from "components/PlayButton";
import PresetModal from "components/PresetModal";
import GenreBadges from "components/GenreBadges";
import CartPlayButtons from "components/CartPlayButtons";

import { addCartItemRequest, cartItemIds } from "../actions";

const PresetCard = ({ dispatch, cart_items_ids, preset_pack, cardSize, mega }) => {
  const [modalShow, setModalShow] = useState(false);
  
  const addPackToCart = (cart_item) => {
    dispatch(addCartItemRequest(cart_item.id));
  };
  
  const inCart = cart_items_ids.includes(preset_pack.id);
  const image = mega ? preset_pack.images.full : preset_pack.images.mid;

  return (
    <>
      <div className={cardSize}>
        <div className="card-img-container position-relative">
          <img 
            src={image}
            style={{ cursor: 'pointer' }}
            onClick={() => setModalShow(true)}
            className="card-img-top"
            alt={preset_pack.name}
          />
          
          {preset_pack.featured && (
            <div className="ribbon"><span>Featured</span></div>
          )}
          
          {preset_pack.is_new && (
            <div className="ribbon"><span>New</span></div>
          )}
          
          <CartPlayButtons 
            addToCart={addPackToCart} 
            preset_pack={preset_pack} 
            inCart={inCart} 
          />
        </div>

        <div className="card-body">
          <span 
            className="card-title" 
            style={{ cursor: 'pointer' }} 
            onClick={() => setModalShow(true)}
          >
            {preset_pack.name}
          </span>

          <br />

          <span>
            by{" "}
            <a href={`/preset_packs/manufacturers/${preset_pack.manufacturer_slug}`}>
              {preset_pack.manufacturer_name}
            </a>
          </span>

          {mega && (
            <>
              <br />
              <hr />
              <div>{preset_pack.description}</div>
            </>
          )}
        </div>
        
        <div className="card-footer">
          <GenreBadges genres={preset_pack.genres} />
        </div>
      </div>

      <PresetModal
        preset_pack={preset_pack}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

const mapStateToProps = state => ({
  cart_items_ids: cartItemIds(state.cart_items)
});

export default connect(mapStateToProps)(PresetCard);
